import React, { useContext, useEffect, useState, useMemo } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger,
  Image,
  Tooltip,
} from "@nextui-org/react";
import TaskMediaApi from "../../services/taskMediaApi";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import dots from "../../Assets/scrapbook/dots-vertical.svg";
import { API_BASE_URL } from "../../config/apiConfig";
// import archiveIcon from "../../Assets/tasks-board/archive-icon.svg"; // You'll need to add this icon
import { PopUpContext } from "Context/PopUpContext";
import axios from "axios";
import { toast } from "react-toastify";
import AddTask from "components/FrondDetails/Tasklist/AddTask";
import DeleteTaskModal from "components/FrondDetails/Tasklist/DeleteTaskModal";
import ViewTask from "components/FrondDetails/Tasklist/ViewTask";
import DataLoader from "pages/DataLoader/DataLoader";
import { Link } from "react-router-dom";

// API base URL constant
// Create axios instance with base URL
const api = axios.create({
  baseURL: API_BASE_URL,
});

export default function ArchivedTasksPage() {
  const [targetId, setTargetId] = useState(null);
  const [itemKey, setItemKey] = useState(null);
  const [editTaskModal, setEditTaskModal] = useState(false);
  const [viewTaskModal, setViewTaskModal] = useState(false);
  const [archivedTasks, setArchivedTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [stats, setStats] = useState({
    total: 0,
    fromDifferentFronds: 0
  });
  const [targetFrondId, setTargetFrondId] = useState(null);

  // Media states
  const [taskMedia, setTaskMedia] = useState({});
  const [mediaErrors, setMediaErrors] = useState({});

  // Lightbox states
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [photoIndex, setPhotoIndex] = useState(0);

  const fetchTaskMedia = async (taskId) => {
    if (taskMedia[taskId] || mediaErrors[taskId]) return;
    
    try {
      console.log('Fetching media for archived task:', taskId);
      const media = await TaskMediaApi.getTaskMedia(authToken, taskId);
      console.log('Media received for archived task', taskId, ':', media);
      
      if (Array.isArray(media) && media.length > 0) {
        setTaskMedia(prev => ({...prev, [taskId]: media}));
      } else {
        setTaskMedia(prev => ({...prev, [taskId]: []}));
      }
    } catch (error) {
      console.error('Error fetching media for archived task', taskId, error);
      setMediaErrors(prev => ({...prev, [taskId]: true }));
    }
  };

  const loadMedia = async (tasks) => {
    if (!tasks || tasks.length === 0) return;
    
    for (const item of tasks) {
      if (item?.task?.id) {
        await fetchTaskMedia(item.task.id).catch(err => {
          console.warn(`Media load failed for archived task ${item.task.id}:`, err);
        });
      }
    }
  };

  // Prepare gallery images for a specific task
  const getTaskGalleryImages = (taskId) => {
    const media = taskMedia[taskId];
    
    if (!media || !Array.isArray(media) || media.length === 0) {
      return [];
    }

    const images = media.filter(m => m.type === 'image' || m.mimeType?.startsWith('image/'));
    
    return images.map((img) => ({
      src: img.thumbnail || img.url || img.original_url,
      width: 1,
      height: 1,
      originalSrc: img.url || img.original_url,
      id: img.id,
      name: img.name || img.filename || `Image ${img.id}`,
      caption: img.caption || '',
    }));
  };

  // Get task documents
  const getTaskDocuments = (taskId) => {
    const media = taskMedia[taskId];
    if (!media || !Array.isArray(media)) return [];
    
    return media.filter(m => m.type === 'document');
  };

  // Get document icon
  const getDocumentIcon = (mimeType) => {
    if (!mimeType) return '📄';
    if (mimeType.includes('pdf')) return '📄';
    if (mimeType.includes('word') || mimeType.includes('document')) return '📝';
    if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return '📊';
    return '📄';
  };

  // Open lightbox for a task's media
  const openLightbox = (taskId, clickIndex) => {
    const media = taskMedia[taskId];
    
    if (!media || !Array.isArray(media) || media.length === 0) return;

    const images = media.filter(m => m.type === 'image' || m.mimeType?.startsWith('image/'));
    
    // Prepare images for lightbox
    const lightboxImagesList = images.map(img => ({
      src: img.url || img.original_url,
      title: img.name || img.filename || `Image ${img.id}`,
      caption: img.caption || '',
    }));

    setLightboxImages(lightboxImagesList);
    setPhotoIndex(clickIndex);
    setLightboxOpen(true);
  };

  // Render task media ALWAYS - show 0 counts for uniform layout (Archive page)
  const renderTaskMedia = (taskId) => {
    const galleryImages = getTaskGalleryImages(taskId);
    const documents = getTaskDocuments(taskId);

    return (
      <div className=" mb-2 space-y-2">
        <div className=" flex justify-between task-card-media">
          {/* Images - always shown */}
          <div className="task-media-section">
            <div className="media-header flex items-center gap-1">
              <span className=" flex items-center gap-1">
                <img width="12" height="12" src="https://img.icons8.com/ios/12/578FCA/image--v1.png" alt="Images" className="task-img" loading="lazy"/>
              <span className="text-xs text-pink-500 font-medium">Images ({galleryImages.length})</span>
              </span>
              
            </div>
            {/* {galleryImages.length > 0 ? (
              <div className="media-thumbnails">
                <Gallery
                  onClick={(index) => openLightbox(taskId, index)}
                  enableImageSelection={false}
                  images={galleryImages}
                  containerWidth={300}
                  thumbnailStyle={{
                    cursor: "pointer",
                    width: "70px",
                    height: "70px",
                    objectFit: "cover",
                    borderRadius: "6px",
                  }}
                  rowHeight={70}
                  margin={2}
                />
              </div>
            ) : (
              <div className="media-placeholder text-xs"></div>
            )} */}
          </div>
          
          {/* Documents - always shown */}
          <div className="task-media-section">
            <div className="media-header">
              <span className="text-base flex items-center gap-1">
                <img width="12" height="12" src="https://img.icons8.com/ultraviolet/12/EB4C4C/live-folder.png" alt="Documents" className="task-img" loading="lazy"/>
                <span className="text-xs text-pink-500 font-medium ">Documents ({documents.length})</span>
              </span>
              
            </div>
            {/* {documents.length > 0 ? (
              <div className="media-thumbnails flex overflow-x-auto gap-1 pb-1">
                {documents.map((doc) => (
                  <div 
                    key={doc.id}
                    className="flex-shrink-0 flex items-center gap-1 px-2 py-1 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors cursor-pointer text-xs"
                    onClick={() => window.open(doc.url, '_blank')}
                  >
                    <span className="text-sm">
                      {getDocumentIcon(doc.mimeType)}
                    </span>
                    <span className="truncate max-w-[80px]">
                      {doc.name || doc.filename || 'Doc'}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="media-placeholder text-xs"></div>
            )} */}
          </div>
        </div>
      </div>
    );
  };

  const authToken = localStorage.getItem("token");

  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  // Add auth token to all requests
  api.interceptors.request.use((config) => {
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    config.headers.Accept = "application/json";
    return config;
  });

  const timeAgo = (dateString) => {
    if (!dateString) return "-";
    const now = new Date();
    const date = new Date(dateString);
    const diffInSeconds = Math.floor((now - date) / 1000);

    const timeUnits = [
      { name: "year", seconds: 31536000 },
      { name: "month", seconds: 2592000 },
      { name: "day", seconds: 86400 },
      { name: "hour", seconds: 3600 },
      { name: "minute", seconds: 60 },
      { name: "second", seconds: 1 },
    ];

    for (const unit of timeUnits) {
      const interval = Math.floor(diffInSeconds / unit.seconds);
      if (interval >= 1) {
        return `${interval} ${unit.name}${interval > 1 ? "s" : ""} ago`;
      }
    }

    return "just now";
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  // Filter tasks based on search query
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredTasks(archivedTasks);
      return;
    }

    const query = searchQuery.toLowerCase().trim();
    const filtered = archivedTasks.filter(item => {
      const task = item?.task || {};
      const owner = item?.owner || {};
      const projectName = item?.project_name || "";
      
      // Search in multiple fields
      return (
        (task.title && task.title.toLowerCase().includes(query)) ||
        (task.description && task.description.toLowerCase().includes(query)) ||
        (owner.name && owner.name.toLowerCase().includes(query)) ||
        (projectName.toLowerCase().includes(query)) ||
        (item?.assigned_to?.some(assignee => 
          assignee.name && assignee.name.toLowerCase().includes(query)
        ))
      );
    });

    setFilteredTasks(filtered);
    
    // Reset to first page when search changes
    setCurrentPage(1);
  }, [searchQuery, archivedTasks]);

  // Get all tasks from /mytasks endpoint
  const getArchivedTasks = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const { data } = await api.get("/mytasks");
      
      const allTasks = data?.response?.data || {};
      
      // Get archived tasks
      const archived = allTasks.archived || [];
      
      // Fallback: filter from other statuses
      let archivedFromOtherStatuses = [];
      if (archived.length === 0) {
        const allTasksArray = [
          ...(allTasks.pending || []),
          ...(allTasks.in_progress || []),
          ...(allTasks.completed || [])
        ];
        archivedFromOtherStatuses = allTasksArray.filter(
          (item) => item?.task?.status === "archived"
        );
      }

      const finalArchivedTasks = archived.length > 0 ? archived : archivedFromOtherStatuses;

      // Get unique frond IDs for stats
      const uniqueFrondIds = new Set(
        finalArchivedTasks.map(item => item?.task?.project_id).filter(Boolean)
      );

      setStats({
        total: finalArchivedTasks.length,
        fromDifferentFronds: uniqueFrondIds.size
      });

      // Sort by creation date (newest first)
      finalArchivedTasks.sort((a, b) => {
        return new Date(b?.task?.created_at) - new Date(a?.task?.created_at);
      });

      setArchivedTasks(finalArchivedTasks);
      setFilteredTasks(finalArchivedTasks); // Initialize filtered tasks
      setSearchQuery(""); // Reset search when fetching new data
      
      // Load media after tasks are set
      if (finalArchivedTasks.length > 0) {
        loadMedia(finalArchivedTasks);
      }
    } catch (error) {
      console.error("Error fetching archived tasks:", error);
      setErrorMessage(error?.response?.data?.message || "Failed to fetch archived tasks");
      toast(error?.response?.data?.message || "Failed to fetch archived tasks", {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getArchivedTasks();
  }, [refreshKey]);

  const { isAddTask } = useContext(PopUpContext);

  useEffect(() => {
    if (isAddTask) {
      getArchivedTasks();
    }
  }, [isAddTask]);

  useEffect(() => {
    if (itemKey === "delete") {
      setOpenDeleteModal(true);
      setItemKey(null);
    } else if (itemKey === "edit") {
      setEditTaskModal(true);
      setItemKey(null);
    } else if (itemKey === "view") {
      setViewTaskModal(true);
      setItemKey(null);
    } else if (itemKey === "pending" || itemKey === "in_progress" || itemKey === "completed") {
      updateTaskStatus(itemKey);
      setItemKey(null);
    }
  }, [itemKey]);

  const openModal = (key, id, frondId) => {
    setItemKey(key);
    setTargetId(id);
    setTargetFrondId(frondId || null);
  };

  // Function to update task status (restore from archive)
  const updateTaskStatus = async (newStatus) => {
    if (!targetId || isUpdating) return;

    setIsUpdating(true);
    try {
      const currentTask = archivedTasks.find(item => item?.task?.id === targetId);
      
      if (!currentTask) {
        toast("Task not found", {
          autoClose: 1500,
          position: "bottom-right",
          hideProgressBar: true,
          className: "rounded-4xl custom-toast error-toast",
        });
        return;
      }

      const payload = {
        title: currentTask?.task?.title,
        description: currentTask?.task?.description || "",
        due_date: currentTask?.task?.due_date || null,
        assigned_to: currentTask?.assigned_to?.map(user => user.id) || [],
        status: newStatus
      };

      await api.put(
        `/tasks/${targetId}`,
        payload
      );

      const statusNames = {
        pending: "Pending",
        in_progress: "In Progress",
        completed: "Completed"
      };

      toast.success(`Task moved to ${statusNames[newStatus] || newStatus}`, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast success-toast",
      });
      
      // Refresh the list
      getArchivedTasks();
      
    } catch (error) {
      console.error("Status update error:", error);
      toast.error(error?.response?.data?.message || "Failed to update task status", {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    } finally {
      setIsUpdating(false);
      setTargetId(null);
    }
  };

  const handleDotsClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Clear search
  const clearSearch = () => {
    setSearchQuery("");
  };

  // Get current user ID
  const [userId, setUserId] = useState(null);

  const getUserData = async () => {
    try {
      const res = await api.get("/user");
      setUserId(res.data?.id);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  // Handle task update/delete
  const handleTaskUpdate = () => {
    setRefreshKey(prev => prev + 1);
  };

  // Pagination
  const ITEMS_PER_PAGE = 9;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (currentPage > Math.ceil(filteredTasks.length / ITEMS_PER_PAGE)) {
      setCurrentPage(Math.max(Math.ceil(filteredTasks.length / ITEMS_PER_PAGE), 1));
    }
  }, [filteredTasks, currentPage]);

  const totalPages = Math.ceil(filteredTasks.length / ITEMS_PER_PAGE);
  const currentItems = filteredTasks.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Hero Section with Theme Gradient */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-pink-500  to-orange-500 mb-8 p-8 shadow-xl">
        {/* Decorative Elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-10 rounded-full transform translate-x-1/3 -translate-y-1/3"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white opacity-10 rounded-full transform -translate-x-1/3 translate-y-1/3"></div>
        
        <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          {/* Title and Description */}
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-3">
              {/* Archive Icon - You can replace with your own icon */}
              <div className="w-12 h-12 bg-white/20 backdrop-blur-lg rounded-2xl flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                </svg>
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-white">Archive</h1>
            </div>
            <p className="text-white/90 text-lg max-w-2xl ml-15">
              View and manage all your archived tasks. Restore them to active status or permanently delete them.
            </p>
          </div>

          {/* Stats Cards */}
          <div className="flex gap-4">
            <div className="bg-white/20 backdrop-blur-lg rounded-2xl p-4 min-w-[120px] text-center">
              <p className="text-white/80 text-sm mb-1">Total Archived</p>
              <p className="text-3xl font-bold text-white">{stats.total}</p>
            </div>
            {/* <div className="bg-white/20 backdrop-blur-lg rounded-2xl p-4 min-w-[120px] text-center">
              <p className="text-white/80 text-sm mb-1">From Fronds</p>
              <p className="text-3xl font-bold text-white">{stats.fromDifferentFronds}</p>
            </div> */}
          </div>
        </div>

        {/* Search Bar with Clear Functionality */}
        <div className="relative z-10 mt-6 max-w-md">
          <div className="flex items-center bg-white/20 backdrop-blur-lg rounded-2xl px-4 py-2">
            <svg className="w-5 h-5 text-white/70 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input 
              type="text" 
              placeholder="Search by title, description, owner, or frond..." 
              className="bg-transparent text-white placeholder-white/70 w-full focus:outline-none border-0 outline-0"
              value={searchQuery}
              onChange={handleSearchChange}
               style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
            />
            {searchQuery && (
              <button 
                onClick={clearSearch}
                className="ml-2 text-white/70 hover:text-white focus:outline-none"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
          
          {/* Search Results Count */}
          {searchQuery && (
            <div className="mt-2 text-white/80 text-sm">
              Found {filteredTasks.length} {filteredTasks.length === 1 ? 'task' : 'tasks'}
            </div>
          )}
        </div>
      </div>

      <section className="archived-tasks-page">
        {errorMessage && (
          <div className="text-white bg-cardColor py-3 text-center rounded-15px text-sm mb-4">
            <span className="bg-clip-text text-transparent bg-mainGradiant font-bold">
              {errorMessage}
            </span>
          </div>
        )}
        
        {isLoading ? (
          <div className="min-h-[400px] flex justify-center items-center w-full">
            <DataLoader />
          </div>
        ) : filteredTasks.length > 0 ? (
          <>
            {/* Grid Layout for Tasks */}
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-5">
              {currentItems.map((item, idx) => (
                <div
                  key={item?.task?.id}
                  className="group bg-white rounded-2xl border-2 border-grayBorder hover:shadow-xl transition-all duration-300 overflow-hidden"
                >
                  {/* Card Header with Gradient based on frond */}
                  <div className="h-2 bg-gradient-to-r from-pink-500  to-orange-500"></div>
                  
<div className="flex flex-col h-full p-5">
                    {/* Header with User Info and Dots */}
                    <div className="flex justify-between items-start mb-4">
                      <Link
                        className={`flex items-center gap-3 ${
                          item?.owner?.id !== userId && "pointer-events-none"
                        }`}
                        to={item?.owner?.id === userId ? `/my-tasks` : null}
                      >
                        <Image
                          src={item?.owner?.img_url || "/default-avatar.png"}
                          classNames={{
                            wrapper: "min-w-[45px] min-h-[45px] max-w-[45px] max-h-[45px] rounded-full",
                          }}
                          className="rounded-full min-w-[45px] min-h-[45px] max-w-[45px] max-h-[45px] object-cover"
                          alt={item?.owner?.name}
                        />
                        <div>
                          <h4 className="text-textColor font-bold leading-tight">
                            {item?.owner?.name || "-"}
                          </h4>
                          <p className="text-xs text-cardGrayColor">
                            {timeAgo(item?.task?.created_at)}
                          </p>
                        </div>
                      </Link>
                      
                      <Dropdown
                        classNames={{
                          content:
                        "min-w-[120px] py-0 px-[5px] rounded-[10px]",
                    }}
                        placement="left-start"
                      >
                        <DropdownTrigger>
                          <button
                            className="w-[24px] h-[24px] opacity-60 group-hover:opacity-100 transition-opacity"
                            onClick={handleDotsClick}
                          >
                            <img
                              src={dots}
                              alt="Dots"
                              className="min-w-[24px] min-h-[24px]"
                            />
                          </button>
                        </DropdownTrigger>
                         <DropdownMenu
                          aria-label="Task Actions"
                          onAction={(key) => openModal(key, item?.task?.id, item?.task?.project_id)}
                          disabledKeys={isUpdating ? ["edit", "delete", "pending", "in_progress", "completed"] : []}
                        >
                          {/* Status Change Section */}
                          <DropdownSection title="Move to" showDivider>
                            <DropdownItem
                              key="pending"
                              className="text-blueTimeline text-sm font-normal py-[2px] px-[5px]"
                              startContent={
                                <span className="w-2 h-2 rounded-full bg-blueTimeline inline-block mr-2"></span>
                              }
                            >
                              Pending
                            </DropdownItem>
                            <DropdownItem
                              key="in_progress"
                              className="text-redTimeline text-sm font-normal py-[2px] px-[5px]"
                              startContent={
                                <span className="w-2 h-2 rounded-full bg-redTimeline inline-block mr-2"></span>
                              }
                            >
                              In Progress
                            </DropdownItem>
                            <DropdownItem
                              key="completed"
                              className="text-greenTimeline text-sm font-normal py-[2px] px-[5px]"
                              startContent={
                                <span className="w-2 h-2 rounded-full bg-greenTimeline inline-block mr-2"></span>
                              }
                            >
                              Completed
                            </DropdownItem>
                          </DropdownSection>
    
                          {/* Edit and Delete Options */}
                          <DropdownItem
                            key="edit"
                            className="text-textColor text-sm font-normal py-[2px] px-[5px] relative after:absolute after:left-0 after:right-0 after:bottom-[-2.5px] after:h-px after:bg-grayBorder my-[5px] selected-action"
                          >
                            Edit
                          </DropdownItem>
                          <DropdownItem
                            key="delete"
                            className="text-[#EB6270] text-sm font-normal py-[2px] px-[5px] selected-action"
                            color="danger"
                          >
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>

                    {/* Assigned Users */}
                    {item?.assigned_to?.length > 0 && (
                      <div className="flex items-center gap-2 mb-3">
                        <span className="text-xs text-cardGrayColor">to</span>
                        <div className="flex items-center gap-1">
                          {item?.assigned_to.map((subItem) => (
                            <Tooltip key={subItem?.id} content={subItem?.name}>
                              <Link
                                className={`${
                                  subItem?.id !== userId && "pointer-events-none"
                                }`}
                                to={subItem?.id === userId ? `/my-tasks` : null}
                              >
                                <Image
                                  src={subItem?.img_url || "/default-avatar.png"}
                                  classNames={{
                                    wrapper: `min-w-[28px] min-h-[28px] max-w-[28px] max-h-[28px] rounded-full ${
                                      subItem?.status ? "grayscale-0" : "grayscale"
                                    }`,
                                  }}
                                  className="rounded-full min-w-[28px] min-h-[28px] max-w-[28px] max-h-[28px] object-cover"
                                />
                              </Link>
                            </Tooltip>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Frond Link */}
                    {item?.task?.project_id && (
                      <Link 
                        to={`/frond/about/${item?.task?.project_id}`}
                        className="inline-flex items-center gap-1 text-sm text-pink-500 hover:text-pink-600 font-medium mb-3 transition-colors"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                        </svg>
                        <span>{item?.project_name || "View Frond"}</span>
                      </Link>
                    )}

                    {/* Task Content - Flex Grow */}
                    <div className="flex-1 flex flex-col">
                      <button
                        type="button"
                        onClick={() => openModal("view", item?.task?.id, item?.task?.project_id)}
                        className="text-left w-full mb-3"
                      >
                        <h3 className="text-lg font-bold text-textColor hover:text-pink-500 transition-colors line-clamp-2">
                          {item?.task?.title || "-"}
                        </h3>
                      </button>
                      
                      {item?.task?.description && (
                        <p className="text-cardGrayColor text-sm line-clamp-3 flex-grow mb-4">
                          {item?.task?.description}
                        </p>
                      )}

                      {/* Task Media */}
                      {renderTaskMedia(item?.task?.id)}
                    </div>

                    {/* Fixed Footer - Always at Bottom */}
                    <div className="mt-auto pt-3 border-t border-grayBorder">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <svg className="w-4 h-4 text-cardGrayColor" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          <span className="text-xs text-cardGrayColor">
                            {formatDate(item?.task?.created_at)}
                          </span>
                        </div>
                        <span className="px-3 py-1 bg-pink-100 text-pink-600 rounded-full text-xs font-medium">
                          Archived
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {filteredTasks?.length > ITEMS_PER_PAGE && (
              <div className="flex justify-center items-center gap-2.5 mt-8">
                <button
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className="px-4 py-2 text-sm bg-gradient-to-r from-pink-500 to-orange-500 rounded-xl text-white font-medium disabled:opacity-50 hover:shadow-lg transition-all"
                >
                  Previous
                </button>
                <span className="text-sm text-textColor font-semibold bg-gray-100 px-4 py-2 rounded-xl">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 text-sm bg-gradient-to-r from-pink-500 to-purple-500 rounded-xl text-white font-medium disabled:opacity-50 hover:shadow-lg transition-all"
                >
                  Next
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 bg-white rounded-2xl border-2 border-grayBorder">
            <div className="w-24 h-24 bg-pink-100 rounded-full flex items-center justify-center mb-4">
              <svg className="w-12 h-12 text-pink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-textColor mb-2">
              {searchQuery ? "No matching tasks" : "No Archived Tasks"}
            </h3>
            <p className="text-cardGrayColor mb-6">
              {searchQuery 
                ? `No tasks found matching "${searchQuery}"` 
                : "You don't have any archived tasks yet."}
            </p>
            {searchQuery ? (
              <button
                onClick={clearSearch}
                className="px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-xl font-medium hover:shadow-lg transition-all"
              >
                Clear Search
              </button>
            ) : (
              <Link 
                to="/my-tasks"
                className="px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-xl font-medium hover:shadow-lg transition-all"
              >
                Go to My Tasks
              </Link>
            )}
          </div>
        )}
      </section>
      
      {editTaskModal && targetId && (
        <AddTask
          isOpen={editTaskModal}
          onClose={() => {
            setEditTaskModal(false);
            handleTaskUpdate();
          }}
          frondId={targetFrondId}
          isModalOpen={true}
          taskId={targetId}
        />
      )}
      {viewTaskModal && targetId && (
        <ViewTask
          isOpen={viewTaskModal}
          onClose={() => {
            setViewTaskModal(false);
          }}
          frondId={targetFrondId}
          taskId={targetId}
        />
      )}
      {openDeleteModal && targetId && (
        <DeleteTaskModal
          isOpen={openDeleteModal}
          onClose={() => {
            setOpenDeleteModal(false);
            handleTaskUpdate();
          }}
          taskId={targetId}
        />
      )}

      {/* Lightbox for fullscreen image viewing */}
      {lightboxOpen && (
        <Lightbox
          mainSrc={lightboxImages[photoIndex]?.src}
          nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]?.src}
          prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]?.src}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % lightboxImages.length)
          }
          imageTitle={lightboxImages[photoIndex]?.title}
          imageCaption={lightboxImages[photoIndex]?.caption}
          reactModalStyle={{ zIndex: 10001 }}
        />
      )}
    </>
  );
}
